import { reactStore } from "../store";
import * as actions from "../store/actions";

const normalizeUser = (value) => {
  if (!value) return '';
  return value.replace('<', '').replace('>', '');
};

const getCheckedOutFilesForUser = (
  files,
  username
) => {
  return (files || []).filter(file => {
    const checkedOutBy = file.CheckedOutBy ?? file.checkedOutBy;
    return normalizeUser(checkedOutBy) === username;
  });
};

export const openCheckInDialog = ({
  selectedItems,
}) => {
  const state = reactStore.getState();
  const { id: currentUser } = state.user;

  const moptions = {
    title: 'Check In',
    width: 1000,
    responsive: true,
    styles: { body: { height: 550 } }
  };  

  const checkedOutFiles = getCheckedOutFilesForUser(
    selectedItems,
    currentUser
  );

  reactStore.dispatch(
    actions.showModal('CHECK_IN', moptions, {
      checkinFiles: checkedOutFiles,
      currentUserId: currentUser
    })
  );
}

export const openUpdateProfileDialog = ({selectedItems}) => {
  const moptions = {
    width: 800,
    responsive: false,
    styles: { body: { height: 500 }},
  }

  reactStore.dispatch(
    actions.showModal('UPDATE_PROFILE', moptions, {
      selectedItems: selectedItems
    })
  );
}

export const openDocumentLogDialog = ({objectId, userId}) => {
  const moptions = {
    title: 'Document Log',
    width: 800,
    responsive: true,
    styles: { body: { height: 500 }},
  }

  reactStore.dispatch(
    actions.showModal('DOCUMENT_LOG', moptions, {
      objectId: objectId,
      userId: userId
    })
  );
}
